import ButtonLarge from 'common/ButtonLarge';
import CreateText from 'common/CreateText';
import styled from 'styled-components';

const ContainerDiv = styled.div`
    background: ${(props) => props.theme.colorBackground};
    width: 100%;
    height: 100%;
    min-height: 400px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .button {
        padding: 0px 60px;
    }

    .text {
        margin: 22px 0px;
    }
`;

export default function EmptyOutOfOffice({ togglePopup }) {
    return (
        <ContainerDiv>
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                    <path
                        d="M17.7962 34.2962L15.2038 31.7038L19.4077 27.5L15.2038 23.2962L17.7962 20.7038L22 24.9077L26.2038 20.7038L28.7962 23.2962L24.5923 27.5L28.7962 31.7038L26.2038 34.2962L22 30.0923L17.7962 34.2962Z"
                        fill="#C4C4C4"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M31.1667 7.33329H34.8333C36.8555 7.33329 38.5 8.97779 38.5 11V36.6666C38.5 38.6888 36.8555 40.3333 34.8333 40.3333H9.16667C7.1445 40.3333 5.5 38.6888 5.5 36.6666V11C5.5 8.97779 7.1445 7.33329 9.16667 7.33329H12.8333V3.66663H16.5V7.33329H27.5V3.66663H31.1667V7.33329ZM9.16667 36.6666H34.837L34.8344 18.3333H9.16667V36.6666ZM9.16667 14.6666H34.8333V11H9.16667V14.6666Z"
                        fill="#C4C4C4"
                    />
                </svg>
            </div>

            <CreateText className="text">
                Set up Out of Office Scheduling
            </CreateText>

            <div style={{ 
                textAlign: 'center', 
                maxWidth: '500px', 
                marginBottom: '32px',
                color: '#666',
                fontSize: '16px',
                lineHeight: '1.5',
                fontFamily: 'Poppins, sans-serif'
            }}>
                Schedule time off for your providers to prevent patients from booking appointments during unavailable periods. 
                Set start and end dates to automatically block their calendar and inform patients about their unavailability.
            </div>

            <div>
                <ButtonLarge onClick={togglePopup} className="button">
                    Schedule an Out of Office
                </ButtonLarge>
            </div>
        </ContainerDiv>
    );
}
